import {
  ARTICLE_DETAIL_FETCH,
  ARTICLE_DETAIL_SUCCESS,
  ARTICLE_DETAIL_FAILURE
} from './actionTypes';

const initialState = {
  isLoaded: false,
  error: []
};

export const articleDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case ARTICLE_DETAIL_FETCH:
      return { ...state, isLoaded: false };
    case ARTICLE_DETAIL_SUCCESS:
      return { ...state, isLoaded: true };
    case ARTICLE_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/ArticleDetail/reducer.js